import React from 'react'
import IntroSection from './components/IntroSection'

const WelcomeSection = () => {
  return (
    <IntroSection id="home" />
  )
}

export default WelcomeSection